export const AMOUNT_PATTERN = /(^\d*\.?\d{0,2}$)/
export const NUMBER_PATTERN = /^\d+$/
export const START_ZERO = /^0+/
export const PHONE_UK_NUMBER_PATTERN = /^\+?(\d){10}$/
export const PASSWORD_PATTERN =
    /^(?=.*[0-9])(?=.*[\W_])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9\W_]{8,50}$/
export const TRANSACTION_ID_PATTERN =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export const EMPTY_PATTERN = /^[ \t]*$/
export const NOT_EMPTY_PATTERN = /^(?![ \t]*$).+/
export const SORT_CODE_PATTERN = /^\d{6}$/
